"use client";

import { APIRoutes } from "@/api";
import { create } from "zustand";

import { useEffect } from "react";
import { Socket, io } from "socket.io-client";

type SocketContextType = {
  socket: Socket | undefined;
  isConnected: boolean;
};

export const useWsStore = create<SocketContextType>(() => ({
  socket: undefined,
  isConnected: false,
}));

export function WsProvider() {
  useEffect(() => {
    console.log("🚀🚀🚀 Starting Socket server: 🚀🚀🚀");

    const socketInstance: Socket = io(process.env.NEXT_PUBLIC_BASE_URL, {
      path: APIRoutes.SOCKET,
      addTrailingSlash: false,
      withCredentials: true,
    });

    socketInstance.on("connect", () => {
      console.log("✅ connected");

      useWsStore.setState({ isConnected: true });
    });

    socketInstance.on("disconnect", (reason: unknown, details: unknown) => {
      console.log("❌ disconnected", { reason, details });
      useWsStore.setState({ isConnected: false });
    });

    socketInstance.on("connect_error", (error) => {
      console.error("🚨🚨🚨 Error connecting to Socket: 🚨🚨🚨");
      console.error(error);
    });

    useWsStore.setState({ socket: socketInstance });

    return () => {
      socketInstance.disconnect();
    };
  }, []);

  return null;
}
